import React from 'react';

const WarningRounded = ({ size = 34, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.8275 22.552L21.7608 6.23203C20.5425 4.0362 18.8567 2.83203 17.0008 2.83203C15.145 2.83203 13.4592 4.0362 12.2408 6.23203L3.17416 22.552C2.02666 24.6345 1.89916 26.632 2.81999 28.2045C3.74082 29.777 5.55416 30.6412 7.93416 30.6412H26.0675C28.4475 30.6412 30.2608 29.777 31.1817 28.2045C32.1025 26.632 31.975 24.6204 30.8275 22.552ZM15.9383 12.7487C15.9383 12.1679 16.42 11.6862 17.0008 11.6862C17.5817 11.6862 18.0633 12.1679 18.0633 12.7487V19.832C18.0633 20.4129 17.5817 20.8945 17.0008 20.8945C16.42 20.8945 15.9383 20.4129 15.9383 19.832V12.7487ZM18.0067 25.0879C17.9358 25.1445 17.865 25.2012 17.7942 25.2579C17.7092 25.3145 17.6242 25.357 17.5392 25.3854C17.4542 25.4279 17.3692 25.4562 17.27 25.4704C17.185 25.4845 17.0858 25.4987 17.0008 25.4987C16.9158 25.4987 16.8167 25.4845 16.7175 25.4704C16.6325 25.4562 16.5475 25.4279 16.4625 25.3854C16.3775 25.357 16.2925 25.3145 16.2075 25.2579C16.1367 25.2012 16.0658 25.1445 15.995 25.0879C15.74 24.8187 15.5842 24.4504 15.5842 24.082C15.5842 23.7137 15.74 23.3454 15.995 23.0762C16.0658 23.0195 16.1367 22.9629 16.2075 22.9062C16.2925 22.8495 16.3775 22.807 16.4625 22.7787C16.5475 22.7362 16.6325 22.7079 16.7175 22.6937C16.9017 22.6512 17.1 22.6512 17.27 22.6937C17.3692 22.7079 17.4542 22.7362 17.5392 22.7787C17.6242 22.807 17.7092 22.8495 17.7942 22.9062C17.865 22.9629 17.9358 23.0195 18.0067 23.0762C18.2617 23.3454 18.4175 23.7137 18.4175 24.082C18.4175 24.4504 18.2617 24.8187 18.0067 25.0879Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export default WarningRounded;
